import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const MoneyBag: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 46 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.1155 31.0604C37.9155 39.0604 18.2822 37.3937 9.11549 35.5604C1.61549 33.3937 -8.28451 26.2604 12.1155 15.0604C32.5155 3.8604 39.9488 6.72706 41.1155 9.5604C43.9488 13.3937 48.3155 23.0604 43.1155 31.0604Z"
        fill="#0BA95E"
        fillOpacity="0.2"
      />
      <path
        d="M8.40895 15.0389C8.08645 15.1577 7.92022 15.5152 8.0377 15.8389L8.43022 16.9189L11.4189 13.9302L8.40895 15.0389Z"
        fill="#1B3029"
      />
      <path
        d="M11.2378 24.6388L13.0378 29.5887C13.094 29.745 13.2115 29.8725 13.3615 29.9412C13.4452 29.98 13.5352 30 13.6252 30C13.699 30 13.7715 29.9875 13.8415 29.9613L15.8277 29.2288L11.2378 24.6388Z"
        fill="#1B3029"
      />
      <path
        d="M37.9621 20.4126L35.9022 14.7489L30.9585 19.6926L33.4084 18.7901C33.7297 18.6675 34.0922 18.8351 34.2109 19.1601C34.3309 19.4838 34.1647 19.8438 33.8409 19.9626L30.7284 21.1101C30.6572 21.1363 30.5847 21.1488 30.5122 21.1488C30.2584 21.1488 30.0184 20.9925 29.926 20.74C29.9247 20.7363 29.926 20.7325 29.9247 20.7288L24.686 25.9675L37.5909 21.2125C37.9146 21.0938 38.0808 20.7363 37.9621 20.4126Z"
        fill="#1B3029"
      />
      <path
        d="M37.8172 10.1827L27.8173 0.18281C27.5736 -0.0609368 27.1773 -0.0609368 26.9336 0.18281L8.18379 18.9326C7.94004 19.1763 7.94004 19.5726 8.18379 19.8163L18.1837 29.8162C18.3049 29.9388 18.4649 30 18.625 30C18.785 30 18.9449 29.9388 19.0674 29.8175L37.8172 11.0677C38.061 10.8227 38.061 10.4277 37.8172 10.1827ZM15.3175 17.3176L12.8175 19.8176C12.695 19.9388 12.535 20.0001 12.375 20.0001C12.215 20.0001 12.055 19.9389 11.9325 19.8176C11.6888 19.5738 11.6888 19.1776 11.9325 18.9338L14.4325 16.4338C14.6762 16.1901 15.0725 16.1901 15.3163 16.4338C15.56 16.6776 15.5612 17.0726 15.3175 17.3176ZM26.1111 18.1113C25.6686 18.5538 25.0674 18.7664 24.3986 18.7664C23.2936 18.7664 22.0024 18.1876 20.9224 17.1064C20.1324 16.3163 19.5774 15.3714 19.3612 14.4464C19.1212 13.4152 19.3187 12.5177 19.9174 11.9177C20.5162 11.3177 21.4136 11.1202 22.4461 11.3615C23.3711 11.5778 24.3161 12.1315 25.106 12.9227C26.8423 14.6576 27.2848 16.9376 26.1111 18.1113ZM34.0673 11.0677L31.5673 13.5677C31.4448 13.6889 31.2848 13.7502 31.1248 13.7502C30.9648 13.7502 30.8048 13.689 30.6823 13.5677C30.4385 13.3239 30.4385 12.9277 30.6823 12.6839L33.1823 10.1839C33.426 9.9402 33.8223 9.9402 34.066 10.1839C34.3098 10.4277 34.311 10.8227 34.0673 11.0677Z"
        fill="#1B3029"
      />
    </svg>
  )
})

MoneyBag.displayName = 'MoneyBag'
